"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }

function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }

var spin = (0, _styledComponents.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);

var Styled = _styledComponents["default"].div.withConfig({
  displayName: "LoadingIndicator__Styled",
  componentId: "mu7ctt-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;svg{animation:", " 700ms ", ";path{fill:", ";&.eye{transition:300ms ease-in-out;opacity:", ";transform:scaleY(", ") fill-box;}}}"], spin, function (props) {
  return props.showSmiley ? "ease-out" : "linear infinite";
}, function (props) {
  var _props$theme$brand, _props$theme$brand$co;

  return ((_props$theme$brand = props.theme.brand) === null || _props$theme$brand === void 0 ? void 0 : (_props$theme$brand$co = _props$theme$brand.colors) === null || _props$theme$brand$co === void 0 ? void 0 : _props$theme$brand$co.primary) || "#9121C2";
}, function (props) {
  return props.showSmiley ? 1 : 0;
}, function (props) {
  return props.showSmiley ? 1 : 0;
});

var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "LoadingIndicator__StyledContent",
  componentId: "mu7ctt-1"
})(["transition:450ms 200ms ease-in-out;opacity:", ";visibility:", ";transform:translateY(", ");text-align:center;padding:", ";"], function (props) {
  return props.showSmiley ? 1 : 0;
}, function (props) {
  return props.showSmiley ? "visible" : "hidden";
}, function (props) {
  return props.showSmiley ? 0 : "25%";
}, function (props) {
  return props.showSmiley ? "6px" : 0;
});

var LoadingIndicator = function LoadingIndicator(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 48 : _ref$size,
      finished = _ref.finished,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showSmiley = _useState2[0],
      setShowSmiley = _useState2[1];

  var handleShowSmiley = (0, _react.useCallback)(function () {
    return setShowSmiley(true);
  }, []);
  (0, _react.useEffect)(function () {
    if (!finished && showSmiley) {
      setShowSmiley(false);
    }
  }, [showSmiley, finished]);
  return /*#__PURE__*/_react["default"].createElement(Styled, {
    showSmiley: showSmiley
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "".concat(size, "px"),
    height: "".concat(size, "px"),
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onAnimationIteration: finished ? handleShowSmiley : undefined
  }, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0_1901_4203)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    opacity: "0.08"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24 38C16.28 38 10 31.72 10 24C10 23.45 10.45 23 11 23C11.55 23 12 23.45 12 24C12 30.62 17.38 36 24 36C30.62 36 36 30.62 36 24C36 23.45 36.45 23 37 23C37.55 23 38 23.45 38 24C38 31.72 31.72 38 24 38Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19 22C20.1046 22 21 20.6569 21 19C21 17.3431 20.1046 16 19 16C17.8954 16 17 17.3431 17 19C17 20.6569 17.8954 22 19 22Z",
    className: "eye"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29 22C30.1046 22 31 20.6569 31 19C31 17.3431 30.1046 16 29 16C27.8954 16 27 17.3431 27 19C27 20.6569 27.8954 22 29 22Z",
    className: "eye"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_1901_4203"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "48",
    height: "48",
    fill: "white"
  })))), /*#__PURE__*/_react["default"].createElement(StyledContent, {
    showSmiley: showSmiley
  }, children));
};

var _default = LoadingIndicator;
exports["default"] = _default;